module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html
// module id = ../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html
// module chunks = 0